module.exports = __webpack_public_path__ + "img/Maths Sharp Shooter Unlocked.61b2b75.png";